module.exports = __webpack_public_path__ + "img/update.d2f558b2.svg";